  import { Menu, Spin, Typography } from "antd";
  import { useNavigate, useMatch,useLocation } from "react-router-dom";
  import { Metrics, Helpers, Colors,Spacing,channelColors as colors,Fonts,Images } from '../../global'
  import DashboardCard from "../../Components/DashboardCard"
  import { Row,Icon,Text } from "../../Components"
  import { ToolTypes } from "../../API";
  // import { ST4C } from '../../Tools'
  import { allSitesAtom } from "../../Atoms/allSitesAtom"
  import { useRecoilValue, useRecoilState } from "recoil"
  import { THP, SA4C, ST4C, SSS1, SCP1, SDP1 } from '../../Tools'
  import {ReactComponent as dashboardIcon} from '../../Assets/SVG/DashboardIcon.svg'
  import {ReactComponent as folderIcon} from '../../Assets/SVG/Folders.svg'
  import {ReactComponent as messageIcon} from '../../Assets/SVG/Messages.svg'
  import {ReactComponent as gearIcon} from '../../Assets/SVG/Settings.svg'
  import _ from 'lodash'
  import "./MobileMenu.css"
  import { View } from "..";
  import { useEffect, useState, useRef } from "react"
  import Folders from "../../Pages/Folders";
  import { useCookies } from 'react-cookie';
  import { useAuthenticator } from '@aws-amplify/ui-react';
  const styles = {
    alertNotification:{
      display:'flex',
      width: 20,
      height: 20,
      borderRadius: 20/2,
      zIndex: 2, // works on ios
      // elevation: 100, // works on android
      left:24,
      top:4,
      paddingBottom:4,
      paddingRight:1,
      position: 'absolute',
      justifyContent:'center',
      alignItems:'center',
      backgroundColor: Colors.error,
      marginLeft:-6,
      marginBottom:18
    },
    alertNotificationText:{
      width: 28,
      height: 28,
      borderRadius: 28/2,
      zIndex: 3, // works on ios
      left:24,
      top:5,
      position: 'absolute',
      justifyContent:'center',
      alignItems:'center',
      backgroundColor: Colors.transparent
    },
  }

  let lastMac
  function MobileMenu({items, rootSubmenuKeys, loading}) {
    const allSites = useRecoilValue(allSitesAtom)
    const location = useLocation();
    const macMatch = useMatch('/site/:mac')
    const [alertLeftOffeset,setAlertLeftOffeset] = useState(195)
    const { user } = useAuthenticator((context) => [context.user]);
    let email = ''
    if(user?.attributes?.email) email = user?.attributes?.email
    const [cookies, setCookie] = useCookies([email]);
    const macAddress = macMatch?.params.mac
    if(macAddress) lastMac = macAddress 
    const { Title } = Typography;
    const [path,setPath] = useState(
      location?.pathname.includes('folders')?'folders':
      location?.pathname.includes('messages')?'messages':
      location?.pathname.includes('settings') || location?.pathname.includes('toolSettings')?'settings':
      'dashboard'
      )
    const ref = useRef();
    const navigate = useNavigate();
    useEffect(() => {
      setPath(
        location?.pathname.includes('folders')?'folders':
        location?.pathname.includes('messages')?'messages':
        location?.pathname.includes('settings') || location?.pathname.includes('toolSettings')?'settings':
        'dashboard'
        )
    }, [location]);
    useEffect(() => {
      alertLength = _.has(allSites,'unreadMessages')? allSites.unreadMessages:0
    }, [allSites]);
    useEffect(() => {
      const observer = new ResizeObserver(entries  => {
          console.log('RESIZE MOBILE:',entries[0].contentRect)
          setAlertLeftOffeset(entries[0].contentRect.width * 2.6)
      })
      if(ref.current){
        observer.observe(ref.current)
      }
      return () => ref.current && observer.unobserve(ref.current)
    }, [ref.current])
    console.log('MobileMenu allSites:', allSites)
    let alertLength = _.has(allSites,'unreadMessages')? allSites.unreadMessages:0
    let alertLengthString =alertLength.toFixed(0)
    if(alertLengthString.length>=5) alertLengthString = "99999+"// alertLengthString = "888"
    if(alertLengthString.length>=3){
      // setAlertLeftOffeset(alertLeftOffeset-(12*(alertLengthString.length-2)))
    }
    return (
      <>
      <View style={{display:'flex',flexDirection: 'column',height:'100%'}}>
      <View style={[Helpers.mainSpaceBetween,{display:'flex',flexDirection: 'row',width:"100%",alignItems:'center',paddingTop:23,paddingBottom:23,overflow:'none'}]}>
        <View style ={{display:'flex',flex:1,...Helpers.center, height: '100%',cursor:'pointer'}} 
          onClick={()=>{
            if(lastMac && _.has(allSites,lastMac)){
              navigate(`/site/${lastMac}`)
            }else{
              navigate(`/`)
            }
            }}><Icon color={path=='dashboard'?Colors.primary:Colors.lightGrey} svg={dashboardIcon} size="sm" /></View>
        <View style ={{display:'flex',flex:1,...Helpers.center, height: '100%',cursor:'pointer'}} onClick={()=>{cookies[email]?.currentSession?navigate(`/folders/${cookies[email].currentSession}`):navigate(`/folders`)}}><Icon color={path=='folders'?Colors.primary:Colors.lightGrey} svg={folderIcon} size="sm" /></View>
        {alertLength>0 && 
          <View onClick={()=>navigate(`/messages`)} style ={[styles.alertNotificationText,{left:alertLeftOffeset,cursor:'pointer',top:10,width:alertLengthString.length>1?(20+(8*(alertLengthString.length-1))):20}]}><Text as="small" color="white">{alertLengthString}</Text></View>
        }
        {alertLength>0 && 
          <View onClick={()=>navigate(`/messages`)} style ={[styles.alertNotification,{left:alertLeftOffeset,cursor:'pointer',top:13,width:alertLengthString.length>1?(20+(8*(alertLengthString.length-1))):20}]}></View> 
        }
        <View style ={{display:'flex',flex:1,...Helpers.center, height: '100%',cursor:'pointer'}} onClick={()=>navigate(`/messages`)}><div ref={ref} style={{height: '100%',width:'100%',...Helpers.center}}><Icon color={path=='messages'?Colors.primary:Colors.lightGrey} svg={messageIcon} size="sm" /></div></View>
        <View style ={{display:'flex',flex:1,...Helpers.center, height: '100%',cursor:'pointer'}} onClick={()=>navigate(`/settings`)}><Icon color={path=='settings'?Colors.primary:Colors.lightGrey} svg={gearIcon} size="sm" /></View>
      </View>
      
      {path=='folders'?<View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderRight:'2px solid',borderRightColor: Colors.light}}>
        <Folders menu={true}/>
        </View>:<View style={{display:'flex',flexDirection: 'column',width:"100%",flex:1,overflow:'auto',borderRight:'2px solid',borderRightColor: Colors.light}}>
        {loading && 
          <div className="loading">
            <Spin size="large" />
          </div>
        }
        {items.length>0?<Row.Section title="Tools"></Row.Section>:loading?<></>:<View style = {{flex:1,width:"100%", ...Metrics.tinyBottomPadding,...Helpers.colCross,}}>
          <img style={{height:180,width:180}} src={Images.noTools} resizeMode={'contain'} /> 
          <Text
            color="primary"
            style={{ ...Helpers.textCenter, ...Fonts.normal, ...Metrics.smallVerticalPadding }}
          >
            {'Your dashboard is empty.\nStart by adding a new tool on the Stratus app'}
          </Text>
          </View>}
        {items.map((tool) => {
          console.log('Mapping tools...')
          return _.has(tool,'mac')?
          <View key={tool.mac + '-dash'}>
            {ToolTypes.THP.localeCompare(tool.toolType) ? (<></>) : (<THP.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.mac}/>)}
            {ToolTypes.SDP.localeCompare(tool.toolType) ? (<></>) : (<SDP1.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.mac}/>)}
            {ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType) ? (<></>) : (<SA4C.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.mac}/>)}
            {ToolTypes.THERMO_4_CH.localeCompare(tool.toolType) ? (<></>) : (<ST4C.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.mac}/>)}
            {ToolTypes.SWIM.localeCompare(tool.toolType) ? (<></>) : (<SSS1.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.mac}/>)}
            {ToolTypes.CHEM.localeCompare(tool.toolType) ? (<></>) : (<SCP1.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.mac}/>)}
          </View>:
          _.has(tool,'share_id')?
          <View key={tool.share_id + '-dash'}>
            {ToolTypes.THP.localeCompare(tool.toolType) ? (<></>) : (<THP.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.share_id}/>)}
            {ToolTypes.SDP.localeCompare(tool.toolType) ? (<></>) : (<SDP1.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.share_id}/>)}
            {ToolTypes.ANALOG_4_CH.localeCompare(tool.toolType) ? (<></>) : (<SA4C.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.share_id}/>)}
            {ToolTypes.THERMO_4_CH.localeCompare(tool.toolType) ? (<></>) : (<ST4C.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.share_id}/>)}
            {ToolTypes.SWIM.localeCompare(tool.toolType) ? (<></>) : (<SSS1.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.share_id}/>)}
            {ToolTypes.CHEM.localeCompare(tool.toolType) ? (<></>) : (<SCP1.ToolDashboardContainer currentTool={tool} navigate={navigate} selected={macAddress == tool.share_id}/>)}
          </View>:<></>
          
        })}
        {/* <Menu
          mode="inline"
          onClick={(item) => {
            navigate(`/site/${item.key}`);
          }}
          selectedKeys={[macAddress]}
          items={items}
        /> */}
      </View>}
      </View>
      </>
    );
  }
  export default MobileMenu;
  